import {create} from "zustand";
import {brightnessCatalog, focusCatalog, levelPositionCatalog} from '../constants/constants';

const useStore = create((set, get) => ({
    focus: '4px',
    brightness: '#00FF00',
    stab: 0,
    level: 100,
    eng: false,
    oscillatorOn: false,
    membraneOn: true,
    generatorOn: false,
    rightRegulatorValue: 0.05,
    durationGeneratorsRegulatorValue: 0.08,
    amplitudeGeneratorsRegulatorValue: 0.00,
    zeroBorderValue: false,
    beforeBorderValueMin: false,
    beforeBorderValueMin1: false,  // new
    beforeBorderValueMin11: false,  // new
    beforeBorderValueMin12: false,  // new
    beforeBorderValueMin2: false,
    beforeBorderValueMiddle: false,
    beforeBorderValueMiddle2: false, // new
    beforeBorderValueMiddle3: false, // new
    beforeBorderValueMiddle4: false, // new
    beforeBorderValueMax: false,
    borderValue: false,
    showValuesStatus: [false, false, false, false, false, false, false, false, false, false, false, false],

    exitGenerator_enterMembrane: false,
    exitMembrane_enterOcsilloscope: false,

    activeExitGenerator: false,
    activeEnterOcsilloscope: false,

    activeEnterMembrane: false,
    activeExitMembrane: false,


    changeFocus: (focusNumber) =>
        set((state) => ({
            focus: focusCatalog[focusNumber]
        })),
    changeBrightness: (brightNumber) =>
        set((state) => ({
            brightness: brightnessCatalog[brightNumber]
        })),
    changeStab: (stabNumber) =>
        set((state) => ({
            stab: stabNumber
        })),
    changeLevel: (levelNumber) =>
        set((state) => ({
            level: levelPositionCatalog[levelNumber]
        })),
    toggleOscillator: (state) =>
        set((state) => ({
            oscillatorOn: !state.oscillatorOn
        })),
    toggleMemrane: (state) =>
        set((state) => ({
            membraneOn: !state.membraneOn
        })),
    toggleGenerator: (state) =>
        set((state) => ({
            generatorOn: !state.generatorOn
        })),
    toggleEng: (state) =>
        set((state) => ({
            eng: !state.eng
        })),
    changeRightRegulatorValue: (value) =>
        set((state) => ({
            rightRegulatorValue: value
        })),
    changeDurationGeneratorsRegulatorValue: (value) =>
        set((state) => ({
            durationGeneratorsRegulatorValue: value
        })),
    changeAmplitudeGeneratorsRegulatorValue: (value) =>
        set((state) => ({
            amplitudeGeneratorsRegulatorValue: value
        })),
    changeValuesStatus: (index) => {
        set((state) => {
            const newShowValuesStatus = [...state.showValuesStatus];
            newShowValuesStatus[index] = true;
            return {
                showValuesStatus: newShowValuesStatus,
            };
        });
    },

    changeActiveExitGenerator: () =>
        set((state) => ({
            activeExitGenerator: !state.activeExitGenerator,
        })),
    changeActiveEnterMembrane: () =>
        set((state) => ({
            activeEnterMembrane: !state.activeEnterMembrane,
        })),
    changeActiveExitMembrane: () =>
        set((state) => ({
            activeExitMembrane: !state.activeExitMembrane,
        })),
    changeActiveEnterOcsilloscope: () =>
        set((state) => ({
            activeEnterOcsilloscope: !state.activeEnterOcsilloscope,
        })),
    changeExitGenerator_EnterMembrane: () =>
        set((state) => ({
            exitGenerator_enterMembrane: true,
        })),
    changeExitMembrane_enterOcsilloscope: () =>
        set((state) => ({
            exitMembrane_enterOcsilloscope: true,
        })),
    resetAllWires: () =>
        set((state) => ({
            activeExitGenerator: false,
            activeEnterOcsilloscope: false,
            activeEnterMembrane: false,
            activeExitMembrane: false,
        })),
    resetFullWires: () =>
        set((state) => ({
            activeExitGenerator: false,
            activeEnterOcsilloscope: false,
            activeEnterMembrane: false,
            activeExitMembrane: false,

            exitGenerator_enterMembrane: false,
            exitMembrane_enterOcsilloscope: false,
        })),
    changeBeforeBorderValueMin: (value) =>
        set((state) => ({
            beforeBorderValueMin: value,
            zeroBorderValue: value === true ? false : state.zeroBorderValue,
            beforeBorderValueMin1: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin11: value === true ? false : state.beforeBorderValueMin11,
            beforeBorderValueMin12: value === true ? false : state.beforeBorderValueMin12,
            beforeBorderValueMin2: value === true ? false : state.beforeBorderValueMin2,
            beforeBorderValueMiddle: value === true ? false : state.beforeBorderValueMiddle,
            beforeBorderValueMiddle2: value === true ? false : state.beforeBorderValueMiddle2,
            beforeBorderValueMiddle3: value === true ? false : state.beforeBorderValueMiddle3,
            beforeBorderValueMiddle4: value === true ? false : state.beforeBorderValueMiddle4,
            beforeBorderValueMax: value === true ? false : state.beforeBorderValueMax,
            borderValue: value === true ? false : state.borderValue,
        })),
    changeBeforeBorderValueMin1: (value) =>
        set((state) => ({
            beforeBorderValueMin1: value,
            zeroBorderValue: value === true ? false : state.zeroBorderValue,
            beforeBorderValueMin: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin11: value === true ? false : state.beforeBorderValueMin11,
            beforeBorderValueMin12: value === true ? false : state.beforeBorderValueMin12,
            beforeBorderValueMin2: value === true ? false : state.beforeBorderValueMin2,
            beforeBorderValueMiddle: value === true ? false : state.beforeBorderValueMiddle,
            beforeBorderValueMiddle2: value === true ? false : state.beforeBorderValueMiddle2,
            beforeBorderValueMiddle3: value === true ? false : state.beforeBorderValueMiddle3,
            beforeBorderValueMiddle4: value === true ? false : state.beforeBorderValueMiddle4,
            beforeBorderValueMax: value === true ? false : state.beforeBorderValueMax,
            borderValue: value === true ? false : state.borderValue,
        })),
    changeBeforeBorderValueMin11: (value) =>
        set((state) => ({
            beforeBorderValueMin11: value,
            zeroBorderValue: value === true ? false : state.zeroBorderValue,
            beforeBorderValueMin1: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin12: value === true ? false : state.beforeBorderValueMin12,
            beforeBorderValueMin2: value === true ? false : state.beforeBorderValueMin2,
            beforeBorderValueMiddle: value === true ? false : state.beforeBorderValueMiddle,
            beforeBorderValueMiddle2: value === true ? false : state.beforeBorderValueMiddle2,
            beforeBorderValueMiddle3: value === true ? false : state.beforeBorderValueMiddle3,
            beforeBorderValueMiddle4: value === true ? false : state.beforeBorderValueMiddle4,
            beforeBorderValueMax: value === true ? false : state.beforeBorderValueMax,
            borderValue: value === true ? false : state.borderValue,
        })),
    changeBeforeBorderValueMin12: (value) =>
        set((state) => ({
            beforeBorderValueMin12: value,

            zeroBorderValue: value === true ? false : state.zeroBorderValue,
            beforeBorderValueMin1: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin11: value === true ? false : state.beforeBorderValueMin11,
            beforeBorderValueMin2: value === true ? false : state.beforeBorderValueMin2,
            beforeBorderValueMiddle: value === true ? false : state.beforeBorderValueMiddle,
            beforeBorderValueMiddle2: value === true ? false : state.beforeBorderValueMiddle2,
            beforeBorderValueMiddle3: value === true ? false : state.beforeBorderValueMiddle3,
            beforeBorderValueMiddle4: value === true ? false : state.beforeBorderValueMiddle4,
            beforeBorderValueMax: value === true ? false : state.beforeBorderValueMax,
            borderValue: value === true ? false : state.borderValue,
        })),
    changeBeforeBorderValueMin2: (value) =>
        set((state) => ({
            beforeBorderValueMin2: value,

            zeroBorderValue: value === true ? false : state.zeroBorderValue,
            beforeBorderValueMin1: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin11: value === true ? false : state.beforeBorderValueMin11,
            beforeBorderValueMin12: value === true ? false : state.beforeBorderValueMin12,
            beforeBorderValueMiddle: value === true ? false : state.beforeBorderValueMiddle,
            beforeBorderValueMiddle2: value === true ? false : state.beforeBorderValueMiddle2,
            beforeBorderValueMiddle3: value === true ? false : state.beforeBorderValueMiddle3,
            beforeBorderValueMiddle4: value === true ? false : state.beforeBorderValueMiddle4,
            beforeBorderValueMax: value === true ? false : state.beforeBorderValueMax,
            borderValue: value === true ? false : state.borderValue,
        })),
    changeBeforeBorderValueMiddle: (value) =>
        set((state) => ({
            beforeBorderValueMiddle: value,

            zeroBorderValue: value === true ? false : state.zeroBorderValue,
            beforeBorderValueMin1: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin11: value === true ? false : state.beforeBorderValueMin11,
            beforeBorderValueMin12: value === true ? false : state.beforeBorderValueMin12,
            beforeBorderValueMin2: value === true ? false : state.beforeBorderValueMin2,
            beforeBorderValueMiddle2: value === true ? false : state.beforeBorderValueMiddle2,
            beforeBorderValueMiddle3: value === true ? false : state.beforeBorderValueMiddle3,
            beforeBorderValueMiddle4: value === true ? false : state.beforeBorderValueMiddle4,
            beforeBorderValueMax: value === true ? false : state.beforeBorderValueMax,
            borderValue: value === true ? false : state.borderValue,
        })),
    changeBeforeBorderValueMiddle2: (value) =>
        set((state) => ({
            beforeBorderValueMiddle2: value,
            zeroBorderValue: value === true ? false : state.zeroBorderValue,
            beforeBorderValueMin1: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin11: value === true ? false : state.beforeBorderValueMin11,
            beforeBorderValueMin12: value === true ? false : state.beforeBorderValueMin12,
            beforeBorderValueMin2: value === true ? false : state.beforeBorderValueMin2,
            beforeBorderValueMiddle: value === true ? false : state.beforeBorderValueMiddle,
            beforeBorderValueMiddle3: value === true ? false : state.beforeBorderValueMiddle3,
            beforeBorderValueMiddle4: value === true ? false : state.beforeBorderValueMiddle4,
            beforeBorderValueMax: value === true ? false : state.beforeBorderValueMax,
            borderValue: value === true ? false : state.borderValue,

        })),
    changeBeforeBorderValueMiddle3: (value) =>
        set((state) => ({
            beforeBorderValueMiddle3: value,
            zeroBorderValue: value === true ? false : state.zeroBorderValue,
            beforeBorderValueMin1: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin11: value === true ? false : state.beforeBorderValueMin11,
            beforeBorderValueMin12: value === true ? false : state.beforeBorderValueMin12,
            beforeBorderValueMin2: value === true ? false : state.beforeBorderValueMin2,
            beforeBorderValueMiddle: value === true ? false : state.beforeBorderValueMiddle,
            beforeBorderValueMiddle2: value === true ? false : state.beforeBorderValueMiddle2,
            beforeBorderValueMiddle4: value === true ? false : state.beforeBorderValueMiddle4,
            beforeBorderValueMax: value === true ? false : state.beforeBorderValueMax,
            borderValue: value === true ? false : state.borderValue,
        })),
    changeBeforeBorderValueMiddle4: (value) =>
        set((state) => ({
            beforeBorderValueMiddle4: value,
            zeroBorderValue: value === true ? false : state.zeroBorderValue,
            beforeBorderValueMin1: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin11: value === true ? false : state.beforeBorderValueMin11,
            beforeBorderValueMin12: value === true ? false : state.beforeBorderValueMin12,
            beforeBorderValueMin2: value === true ? false : state.beforeBorderValueMin2,
            beforeBorderValueMiddle: value === true ? false : state.beforeBorderValueMiddle,
            beforeBorderValueMiddle2: value === true ? false : state.beforeBorderValueMiddle2,
            beforeBorderValueMiddle3: value === true ? false : state.beforeBorderValueMiddle3,
            beforeBorderValueMax: value === true ? false : state.beforeBorderValueMax,
            borderValue: value === true ? false : state.borderValue,
        })),
    changeBeforeBorderValueMax: (value) =>
        set((state) => ({
            beforeBorderValueMax: value,
            zeroBorderValue: value === true ? false : state.zeroBorderValue,
            beforeBorderValueMin1: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin11: value === true ? false : state.beforeBorderValueMin11,
            beforeBorderValueMin12: value === true ? false : state.beforeBorderValueMin12,
            beforeBorderValueMin2: value === true ? false : state.beforeBorderValueMin2,
            beforeBorderValueMiddle: value === true ? false : state.beforeBorderValueMiddle,
            beforeBorderValueMiddle2: value === true ? false : state.beforeBorderValueMiddle2,
            beforeBorderValueMiddle3: value === true ? false : state.beforeBorderValueMiddle3,
            beforeBorderValueMiddle4: value === true ? false : state.beforeBorderValueMiddle4,
            borderValue: value === true ? false : state.borderValue,
        })),
    changeBorderValue: (value) =>
        set((state) => ({
            borderValue: value,
            zeroBorderValue: value === true ? false : state.zeroBorderValue,
            beforeBorderValueMin1: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin11: value === true ? false : state.beforeBorderValueMin11,
            beforeBorderValueMin12: value === true ? false : state.beforeBorderValueMin12,
            beforeBorderValueMin2: value === true ? false : state.beforeBorderValueMin2,
            beforeBorderValueMiddle: value === true ? false : state.beforeBorderValueMiddle,
            beforeBorderValueMiddle2: value === true ? false : state.beforeBorderValueMiddle2,
            beforeBorderValueMiddle3: value === true ? false : state.beforeBorderValueMiddle3,
            beforeBorderValueMiddle4: value === true ? false : state.beforeBorderValueMiddle4,
            beforeBorderValueMax: value === true ? false : state.beforeBorderValueMax,
        })),
    changeZeroBorderValue: (value) =>
        set((state) => ({
            zeroBorderValue: value,
            borderValue: value === true ? false : state.borderValue,
            beforeBorderValueMin1: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin: value === true ? false : state.beforeBorderValueMin1,
            beforeBorderValueMin11: value === true ? false : state.beforeBorderValueMin11,
            beforeBorderValueMin12: value === true ? false : state.beforeBorderValueMin12,
            beforeBorderValueMin2: value === true ? false : state.beforeBorderValueMin2,
            beforeBorderValueMiddle: value === true ? false : state.beforeBorderValueMiddle,
            beforeBorderValueMiddle2: value === true ? false : state.beforeBorderValueMiddle2,
            beforeBorderValueMiddle3: value === true ? false : state.beforeBorderValueMiddle3,
            beforeBorderValueMiddle4: value === true ? false : state.beforeBorderValueMiddle4,
            beforeBorderValueMax: value === true ? false : state.beforeBorderValueMax,
        })),
}));
export default useStore;
